<template>
  <div>
    <div class="grid-row d-flex_between">
      <div class="grid-col color-gray">Размер:</div>
      <div class="grid-col">
        <div @click="showPopup()" class="btn color-tertiary hover-color-dark">
          <span class="d-block mr-8">Как выбрать размер</span>
          <Icon iconName="icon-chevron-right" className="icon-20" />
        </div>
      </div>
    </div>

    <teleport to="#product-element__popup-container-vue">
      <transition name="fade">
        <div class="popup d-flex_middle popup_md-bottom" v-if="isShow">
          <div class="popup__layout" @click="closePopup()"></div>
          <div
            class="popup__wrap p-16 p-md-0 scroll scroll_y w-100 active-move-down"
            v-bind:class="{ 'is-active': isAnimate }"
          >
            <div
              class="popup__block popup__block_lg bg-white border-radius-xl p-24 p-md-16 mx-auto"
            >
              <div class="grid-row d-flex_middle grid-row_md">
                <div class="grid-col grid-col_full">
                  <div class="fs-28 fw-semibold fs-sm-20">
                    Сопоставление размеров
                  </div>
                </div>

                <div class="grid-col">
                  <div
                    class="btn color-gray hover-color-dark"
                    @click="closePopup()"
                  >
                    <Icon iconName="icon-close" className="icon-24" />
                  </div>
                </div>
              </div>

              <div class="mt-32">
                <TableSizes />
              </div>
            </div>
          </div>
          <!-- /popup__wrap -->
        </div>
      </transition>
    </teleport>
  </div>
</template>

<script>
import Icon from "../Icon/Icon.vue";
import TableSizes from "../TableSizes/TableSizes.vue";
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
//import Preloader from "@/pages/product_card/components/Preloader/Preloader.vue";

export default {
  name: "PopupTableSizes",
  components: {
    //Preloader,
    Icon,
    TableSizes,
  },
  data() {
    return {
      isShow: false,
      isAnimate: false,
    };
  },
  setup() {
    const storeCatalog = useProductStore();

    return {
      storeCatalog,
    };
  },
  provide() {
    return {
      closePopup: this.closePopup,
    };
  },
  methods: {
    showPopup() {
      this.isShow = true;
      setTimeout(() => {
        this.isAnimate = true;
      }, 2);
    },
    closePopup() {
      this.isAnimate = false;
      setTimeout(() => {
        this.isShow = false;
      }, 150);
    },
  },
};
</script>

<!-- <style lang="scss">
@import "./popup.scss";
</style> -->
